export default {
    auth: "/api/auth/authLogin",
    checkIp: "/api/auth/checkIp"
}